import { Endpoint } from "@/types/endpoint";
import { handleRequest } from "..";
import { httpAuthorized } from "@/main";

export const getEndpointListApi = async (
  shipId: string
): Promise<Endpoint[] | null> => {
  return handleRequest<Endpoint[]>(
    httpAuthorized.get("/endpoint/getEndpointList", {
      params: {
        shipId: shipId,
      },
    }),
    (data) => data.data.endpoints
  );
};

export const getEndpointInfoApi = async (
  endpointId: string
): Promise<Endpoint | null> => {
  return handleRequest<Endpoint>(
    httpAuthorized.get("/endpoint/getEndpointInfo", {
      params: {
        endpointId: endpointId,
      },
    }),
    (data) => data.data.endpoint
  );
};

export const generateEndpointsApi = async (
  number: number,
  namePrefix: string,
  typePrefix: string,
  oneTimeCode: string
): Promise<Endpoint[] | null> => {
  return handleRequest<Endpoint[]>(
    httpAuthorized.post("/endpoint/generateEndpoints", {
      number: number,
      namePrefix: namePrefix,
      typePrefix: typePrefix,
      oneTimeCode: oneTimeCode,
    }),
    (data) => data.data.result
  );
};

export const getAllEndpointListApi = async (): Promise<Endpoint[] | null> => {
  return handleRequest<Endpoint[]>(
    httpAuthorized.get("/endpoint/getAllEndpointList"),
    (data) => data.data.endpoints
  );
};
